import styled from '@emotion/styled'
import { breakpoint, calcRem } from '../../../__styling'

export const StyledAppDownloadQrCodeContainer = styled('div')(({ theme }) => ({
    // Hide the QR code for mobile devices
    display: 'none',

    // Display the QR code desktop only
    [breakpoint('md')]: {
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'flex-start',
        alignItems: 'center',
        width: 'fit-content',
        gap: calcRem(4),
        paddingTop: calcRem(8),
        paddingLeft: calcRem(8),
        paddingRight: calcRem(8),
        paddingBottom: calcRem(10),
        borderRadius: calcRem(8),
        backgroundColor: theme.colors.background.primary,
        boxShadow: '0px 2.67px 13.33px 0px rgba(255, 255, 255, 0.5)',
    },
}))

export const StyledAppDownloadQrCode = styled('img')({
    width: calcRem(120),
    height: calcRem(120),
})

export const StyledAppDownloadQrCodeText = styled('p')(({ theme }) => ({
    color: theme.colors.text.primary,
    fontFamily: theme.fonts.sansSerif,
    fontWeight: 500,
    fontSize: calcRem(12),
    lineHeight: calcRem(16),
    margin: 0,
    padding: 0,
}))

export const AppDownloadButtonsSection = styled('div')({
    width: '100%',
    gap: calcRem(12),

    // We only want to display it on mobile devices
    display: 'flex',

    // Hide it on larger devices
    [breakpoint('md')]: {
        display: 'none',
    },
})

export const StyledDownloadAppButton = styled('a')<{ inverse?: boolean }>(
    ({ theme, inverse }) => ({
        backgroundColor: inverse
            ? 'transparent'
            : theme.colors.background.primary,
        // Color overlay workaround
        backgroundImage: inverse
            ? 'none'
            : 'linear-gradient(rgba(4, 61, 226, 0.06), rgba(4, 61, 226, 0.06))',
        color: inverse ? 'white' : theme.colors.brand,
        fontFamily: theme.fonts.sansSerif,
        fontWeight: 500,
        fontSize: calcRem(18),
        lineHeight: calcRem(20),
        padding: `${calcRem(14)} ${calcRem(24)}`,
        border: inverse ? `1px solid #FFFFFF` : 'none',
        textDecoration: 'none',
        boxShadow: inverse
            ? '0px 2.67px 13.33px 0px rgba(255, 255, 255, 0.37)'
            : 'none',
        borderRadius: calcRem(2),
        '&:hover': {
            backgroundImage: inverse
                ? 'linear-gradient(rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14))'
                : 'linear-gradient(rgba(4, 61, 226, 0.02), rgba(4, 61, 226, 0.02))',
        },
        '&:active': {
            backgroundImage: inverse
                ? 'linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))'
                : 'linear-gradient(rgba(4, 61, 226, 0.06), rgba(4, 61, 226, 0.06))',
        },
    }),
)
